import Axios from "axios";

let rate_us_api = `${process.env.VUE_APP_API_HOST || ""}/api/rate_us`;

export default {
  namespaced: true,
  state: {
    all: null,
    // rate: null,
    // tellUs: null,
  },
  mutations: {
    fetchRateUs(state, { res }) {
      state.all = res.data;
    },
    addRateUs() {
      // console.log('mutations addRateUs', payload);
    },
  },
  actions: {
    // async fetchRateUs({ commit }) {
    //   await Axios.get(rate_us_api)
    //     .then(res => commit("fetchRateUs", { res }))
    //     .catch(err => alert(err));
    // },
    async addRateUs({ commit }, payload) {
      await Axios.post(rate_us_api, payload)
        .then(() => commit("addRateUs", { payload }))
        .catch((err) => alert(err));
    },
  },
  getters: {
    // getRate(state) {
    //   return state.rate;
    // },
    // getTellUs(state) {
    //   return state.tellUs;
    // },
  },
};
